import ThemeBase from './Base'
class ThemeDefault extends ThemeBase {
    constructor() {
        super()
    }
}

const theme = new ThemeDefault()
export default theme
